// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2t86d","content":"RecentSearches_content__1AuPl"};